import React from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import SaleOrderAjaxCart from "./components/SaleOrderAjaxCart";
import SaleOrderAjaxWishList from "./components/SaleOrderAjaxWishList";
import SaleOrderAjaxSuccess from "./components/SaleOrderAjaxSuccess";
import {number_format} from "./components/Functions/NumberFormat";

class SaleOrderAjax extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            preloader: true,
            wishList: [],
            basketItems: [],
            orderProps: [],
            totalPrice: 0,
            deliveryPrice: 600 //Если totalPrice > this.freeDelivery - 0;
        };

        this.zeroPrice = 'Цена по запросу';
        this.freeDelivery = 0;


        this.server = (window.location.hostname === 'localhost') ? 'https://fancoil-kkb.ru' : '';
        this.timer = false;

        this._onChangeBasketHandle = this._onChangeBasketHandle.bind(this);
        this._onMoveToBasket = this._onMoveToBasket.bind(this);
        this._onRemoveWishListItem = this._onRemoveWishListItem.bind(this);
        this._onRemoveBasketItem = this._onRemoveBasketItem.bind(this);
        this._onOrder = this._onOrder.bind(this);

        this.getFFB()

        this.setToFFB = this.setToFFB.bind(this);
    }

    componentDidMount() {

        const options = {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({action: 'getItems'})
        }

        fetch(this.server + '/ajax/react/sale.order.ajax.php', options)
            .then(res => res.json())
            .then(json => this.setState({
                preloader: false,
                wishList: json.wishList,
                basketItems: json.basketItems,
                orderProps: json.orderProps,
                totalPrice: json.totalPrice,
                deliveryPrice: (json.totalPrice > this.freeDelivery) ? 0 : 600
            })).catch(e => {
                console.log({e})
            }
        )
    }

    _onOrder(event) {
        event.preventDefault();
        this.setState({preloader: true})
        if (event.target.className.indexOf('busy') + 1) {
            this.setState({preloader: false});
            return
        }
        event.target.classList.add('busy');

        let formData = new FormData(event.target);

        const {orderProps} = this.state;
        // console.log(orderProps);
        let success = true;
        for (let prop of orderProps.items) {
            if (prop.req === 'Y') {
                let field = document.getElementById(prop.property_id);
                if (field.value.length > 0) field.classList.remove('is-error');
                else {
                    success = false;
                    field.classList.add('is-error');
                }
            }
        }

        if (success) {
            fetch(this.server + '/ajax/order.php', {
                credentials: 'include',
                method: 'POST',
                body: formData
            })
                .then(res => res.json())
                .then(json => {
                    sessionStorage.setItem('date', json.date);
                    sessionStorage.setItem('orderId', json.ORDER_ID);
                    sessionStorage.setItem('customerName', formData.get('ORDER_PROP_1'));
                    if (typeof json.ORDER_ID === "undefined") {
                        console.log({json})
                        event.target.classList.remove('busy');
                    } else {
                        window.location.href = "/cart/success/" + json.ORDER_ID + "/"
                    }
                })
                .finally(() => this.setState({preloader: false}))
            ;
        } else {
            this.setState({preloader: false})
            event.target.classList.remove('busy')
        }
    }

    _onRemoveBasketItem(id) {
        let {basketItems} = this.state;
        let totalPrice = 0;
        let deliveryPrice;

        let needleItem;

        for (let i in basketItems) {
            if (basketItems[i].id === id) {
                needleItem = i;
            } else {
                totalPrice += basketItems[i].price * basketItems[i].quantity;
            }
        }

        fetch(this.server + '/ajax/react/sale.order.ajax.php', {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({
                action: 'delete',
                id: id
            })
        }).then(res => res.json());

        basketItems.splice(needleItem, 1);

        deliveryPrice = (totalPrice > this.freeDelivery) ? 0 : 600;

        this.setState({basketItems, totalPrice, deliveryPrice});
    }

    _onChangeBasketHandle(value, index) {
        index = index.toString();
        let basketItems = this.state.basketItems;
        let totalPrice = 0;
        let deliveryPrice = 0;

        for (let i in basketItems) {
            if (i === index) {
                basketItems[index].quantity = value;
            }

            totalPrice += basketItems[i].price * basketItems[i].quantity;
        }

        deliveryPrice = (totalPrice > this.freeDelivery) ? 0 : 600;

        clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            fetch(this.server + '/ajax/react/sale.order.ajax.php', {
                method: 'POST',
                credentials: 'include',
                body: JSON.stringify({
                    action: 'updateQuantity',
                    id: basketItems[index].id,
                    value: value,
                })
            }).then(res => res.json());
        }, 300);

        this.setState({basketItems, totalPrice, deliveryPrice});
    }

    _onMoveToBasket(id) {
        let {wishList, basketItems} = this.state;
        let totalPrice = 0;
        let deliveryPrice = 0;
        let i;

        for (i in wishList) {
            if (wishList[i].id === id) {

                fetch(this.server + '/ajax/react/sale.order.ajax.php', {
                    method: 'POST',
                    credentials: 'include',
                    body: JSON.stringify({
                        action: 'moveToBasket',
                        id: id
                    })
                }).then(res => res.json());

                basketItems.push(wishList[i]);
                wishList.splice(i, 1);
                break;
            }
        }

        for (i in basketItems) {
            totalPrice += basketItems[i].price * basketItems[i].quantity;
        }

        deliveryPrice = (totalPrice > this.freeDelivery) ? 0 : 600;

        this.setState({wishList, basketItems, totalPrice, deliveryPrice});
    }

    _onRemoveWishListItem(id) {
        let {wishList} = this.state;

        for (let i in wishList) {
            if (wishList[i].id === id) {

                fetch(this.server + '/ajax/react/sale.order.ajax.php', {
                    method: 'post',
                    credentials: 'include',
                    body: JSON.stringify({
                        action: 'delete',
                        id: id
                    })
                }).then(res => res.json());

                wishList.splice(i, 1);
                break;
            }
        }

        this.setState({wishList});
    }

    render() {
        if (this.state.preloader) {
            return (
                <div id="preloader">
                    <div/>
                </div>
            )
        } else {
            const basketItems = this.state.basketItems.length;
            const wishListItems = this.state.wishList.length;

            console.log({ico: this.FFBbasket})
            if (null !== this.FFBbasket.icon)
             this.setToFFB(this.state.basketItems, this.state.wishList);

            return (
                <Router>
                    <Switch>
                        <Route
                            exact path="/cart/"
                            render={() => {
                                if (basketItems === 0 && wishListItems === 0)
                                    window.location.href = '/catalog/';
                                else if (basketItems === 0)
                                    return (<Redirect to="/cart/wishlist/"/>);
                                else
                                    return (
                                        <SaleOrderAjaxCart
                                            wishList={this.state.wishList}
                                            basketItems={this.state.basketItems}
                                            orderProps={this.state.orderProps}
                                            totalPrice={this.state.totalPrice}
                                            zeroPrice={this.zeroPrice}
                                            deliveryPrice={this.state.deliveryPrice}
                                            _onChangeBasketHandle={(value, index) => this._onChangeBasketHandle(value, index)}
                                            _onRemoveBasketItem={id => this._onRemoveBasketItem(id)}
                                            _onOrder={this._onOrder}

                                        />
                                    );
                            }}
                            basketItems={this.state.basketItems}
                            totalPrice={this.state.totalPrice}
                        />
                        <Route
                            path="/cart/wishlist/"
                            render={() => {
                                if (basketItems === 0 && wishListItems === 0)
                                    window.location.href = '/catalog/';
                                else if (wishListItems === 0)
                                    return (<Redirect to="/cart/"/>);
                                else
                                    return (<SaleOrderAjaxWishList
                                        wishList={this.state.wishList}
                                        basketItems={this.state.basketItems}

                                        _onMoveToBasket={id => this._onMoveToBasket(id)}
                                        _onRemoveWishListItem={id => this._onRemoveWishListItem(id)}
                                    />);
                            }}
                            wishList={this.state.wishList}
                        />
                        <Route path="/cart/success/:order_id/" component={SaleOrderAjaxSuccess}/>
                    </Switch>
                </Router>
            )
        }
    }

    getFFB() {
        const _this = this;
        document.addEventListener("DOMContentLoaded", () => {
            _this.FFBbasket = {
                icon: document.getElementById('ffbBasketItem'),
                counter: document.getElementById('ffbBasketCounter'),
                sum: document.getElementById('FFB_TOTAL_PRICE'),
            };
            _this.FFBdelay = {
                icon: document.getElementById('ffbWishListItem'),
                counter: document.getElementById('ffbWishListCounter'),
            };
        })
    }

    setToFFB(basketItems, wishList) {
        if (null === this.FFBbasket.icon) return
        if (null === this.FFBdelay.icon) return
        //Корзина
        let basketCount = 0, totalPrice = 0;

        basketItems.forEach(item => {
            totalPrice += item.quantity * item.price;
            basketCount += item.quantity;
        });

        this.FFBbasket.counter.innerText = basketCount;
        this.FFBbasket.sum.innerHTML = number_format(totalPrice, 0, ".", " ");
        (totalPrice > 0) ? this.FFBbasket.icon.classList.remove('is-empty') : this.FFBbasket.icon.classList.add('is-empty');

        // Отложенные
        let wishCount = 0;

        wishList.forEach(item => {
            wishCount += 1;
        });

        this.FFBdelay.counter.innerText = wishCount;
        (wishCount > 0) ? this.FFBdelay.icon.classList.remove('is-empty') : this.FFBdelay.icon.classList.add('is-empty');
    }

}

export default SaleOrderAjax;